import { useQuery } from "@tanstack/react-query";

import { ILanguageResponse } from "../../@types/Translations";
import { translationService } from "../../services/translationsService";

export const LANGUAGES_QUERY_KEY = "languages";

/** The surface whose translations decide which languages the portal may offer. */
export const PORTAL_USED_LOCATION = "Portal";

/**
 * EN-5191: the languages the platform has translations for, for the Settings selector.
 *
 * Filtered to the languages that have portal translations, not every registered code: the
 * registry lists codes, and a language with no Portal rows renders as the English fallback.
 * Offering one would read as a broken setting rather than a missing translation.
 */
export function useLanguages() {
  const { data, isFetching, isError } = useQuery({
    queryKey: [LANGUAGES_QUERY_KEY, PORTAL_USED_LOCATION],
    queryFn: async () => {
      const response = await translationService.getLanguages(
        PORTAL_USED_LOCATION
      );
      return response.data ?? [];
    },
    // Languages are added by a migration, not during a session.
    staleTime: Infinity,
  });

  return {
    languages: (data ?? []) as ILanguageResponse[],
    isLanguagesFetching: isFetching,
    isLanguagesError: isError,
  };
}
